import React from "react"
import { Button, Dropdown, Tag } from "antd"
import { MoreOutlined } from "@ant-design/icons"
import styles from "../index.module.css"
import { STATUS_COLOR, formatValue, formatDateRange, formatCap } from "./discountUtils"

const formatApplicableExperiences = (applicable_experiences) => {
  if (applicable_experiences === "all") return "All"
  if (Array.isArray(applicable_experiences)) return String(applicable_experiences.length)
  return "0"
}

export const getDiscountColumns = (getMenuItems, isMutating, t, onAssignClick) => [
  {
    title: t("settings.discount_col_name"),
    dataIndex: "name",
    key: "name"
  },
  {
    title: t("settings.discount_col_code"),
    dataIndex: "code",
    key: "code",
    render: (code) => <Tag>{code}</Tag>
  },
  {
    title: t("settings.discount_col_value"),
    key: "value",
    render: (_, record) => formatValue(record),
    width: 110
  },
  {
    title: t("settings.column_status"),
    dataIndex: "status",
    key: "status",
    width: 110,
    render: (status) => (
      <Tag color={STATUS_COLOR[status] ?? "default"}>
        {status === "active" ? t("settings.status_active") : t("settings.status_inactive")}
      </Tag>
    )
  },
  {
    title: t("settings.discount_col_validity"),
    key: "validity",
    render: (_, record) => formatDateRange(record.valid_from, record.valid_until),
    width: 240
  },
  {
    title: t("settings.discount_col_usage"),
    key: "usage",
    width: 140,
    render: (_, record) => `${record.usage_count ?? 0} / ${formatCap(record.usage_cap)}`
  },
  {
    title: t("settings.discount_col_per_guest_limit", "Per-Guest Limit"),
    key: "per_user_usage_cap",
    width: 130,
    render: (_, record) => formatCap(record.per_user_usage_cap)
  },
  {
    title: t("settings.discount_col_experiences"),
    key: "applicable_experiences",
    width: 150,
    render: (_, record) => {
      const val = formatApplicableExperiences(record.applicable_experiences)
      const label = record.applicable_experiences === "all"
        ? t("settings.discount_experiences_all")
        : val
      return (
        <button type="button" className={styles.assignedExperiencesCell} onClick={() => onAssignClick?.(record)}>
          {label}
        </button>
      )
    }
  },
  {
    title: "",
    key: "actions",
    align: "right",
    width: 60,
    render: (_, record) => (
      <Dropdown
        menu={{ items: getMenuItems(record) }}
        trigger={["click"]}
        placement="bottomRight"
        disabled={isMutating}
      >
        <Button type="text" icon={<MoreOutlined />} onClick={(e) => e.stopPropagation()} />
      </Dropdown>
    )
  }
]
